import {realmConfig} from './realmConfig';

export const usernameEnabled = () => realmConfig.get('login.username');
